import React, { useState } from "react";
import { IoMdMail } from "react-icons/io";
import { zodResolver } from "@hookform/resolvers/zod";
import { IoIosCall } from "react-icons/io";
import { CiLocationOn } from "react-icons/ci";
import { useForm } from "react-hook-form";
import { FormSchema } from "../../../main/form/validation";
import toast from "react-hot-toast";
import axios from "axios";
import { PiSpinnerBold } from "react-icons/pi";

const ContactFormMain = () => {
  const {
    register,
    handleSubmit,
    reset,

    formState: { errors },
  } = useForm({
    resolver: zodResolver(FormSchema),
  });

  let [state, setState] = useState(false);

  return (
    <section
      id="contact"
      className=" grid grid-cols-[50%_500px] gap-16 py-20 max-w-7xl m-auto mt-6t max-sm:px-5 max-sm:grid-cols-1">
      <div className="bg-formImg-png">
        <div className="max-w-[444px] m-auto mt-6">
          <h2 className="mb-5 text-[#2B3A67] text-2xl font-semibold max-sm:text-lg">
            Contact Us
          </h2>
          <p className="text-lg text-[#4A4A4A] font-normal mb-5 max-sm:text-base">
            Our team will reach out within 24 hours to discuss how we can help
            you grow your career.
          </p>
          <ul className="text-[#4A4A4A] space-y-4 ">
            <li className="flex items-center gap-2">
              {" "}
              <IoMdMail className="text-primary  " size={24} />{" "}
              Academicainsightirs@gmail.com
            </li>
            <li className="flex items-center gap-2">
              {" "}
              <IoIosCall className="text-primary" size={24} /> +91 9361319990
            </li>
            <li className="flex items-center gap-2">
              {" "}
              <CiLocationOn className="text-primary" size={24} /> Polur, Tamil
              Nadu.
            </li>
          </ul>
        </div>
      </div>
      <form
        onSubmit={handleSubmit(async (data) => {
          try {
            setState(true);
            let postData = await axios.post(
              "https://vercel-deployment-w4ja.onrender.com/api/request_submission",
              data
            );

            if (postData.status === 200 || postData.status === 201) {
              reset();
              toast.success("Request has been Submitted !");
            } else {
              toast.error("Network Error !");
            }
          } catch (error) {
            console.log(error);
          } finally {
            setState(false);
          }
        })}
        className="flex flex-col gap-3 bg-[#f5f5f5] p-9 rounded-sm max-sm:px-5">
        <h2 className="mb-2 text-[#2B3A67] text-2xl font-semibold max-sm:text-xl">
          {" "}
          Reach Out and Grow
        </h2>
        <p className="text-[#4A4A4A] text-lg font-normal max-sm:text-base">
          Fill in your details, and let’s start building your career today!
        </p>
        <div className="flex flex-col gap-[2px]">
          <label className="text-[#4A4A4A] text-sm font-medium">Name</label>
          <input
            className="border shadow-xs focus:outline-none border-slate-200 font-normal text-slate-600 rounded-md py-[0.380rem] px-2 text-sm"
            type="text"
            {...register("name")}
            placeholder="Enter Your Name"
          />
          <p className="text-red-500 text-xs mt-1 ml-2 font-normal">
            {errors["name"] && errors["name"]?.message}
          </p>
        </div>
        <div className="flex flex-col gap-[2px]">
          <label className="text-[#4A4A4A] text-sm font-medium">
            Phone Number
          </label>
          <input
            className="border focus:outline-none shadow-xs border-slate-200 font-normal text-slate-600 rounded-md py-[0.380rem] px-2 text-sm [appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none"
            type="number"
            {...register("phone")}
            placeholder="Enter Your Phone Number"
          />
          <p className="text-red-500 text-xs mt-1 ml-2 font-normal">
            {errors["phone"] && errors["phone"]?.message}
          </p>
        </div>
        <div className="flex flex-col gap-[2px]">
          <label className="text-[#4A4A4A] text-sm font-medium">Email-ID</label>
          <input
            className="border focus:outline-none shadow-xs border-slate-200 font-normal text-slate-600 rounded-md py-[0.380rem] px-2 text-sm"
            type="text"
            {...register("email")}
            placeholder="Enter Your Email ID"
          />
          <p className="text-red-500 text-xs mt-1 ml-2 font-normal">
            {errors["email"] && errors["email"]?.message}
          </p>
        </div>
        <div className="flex flex-col gap-[2px]">
          <label className="text-[#4A4A4A] text-sm font-medium">
            Write your Message.
          </label>
          <textarea
            className="border focus:outline-none shadow-xs border-slate-200 font-normal text-slate-600 rounded-md py-[0.380rem] px-2 text-sm"
            type="text"
            {...register("message")}
            placeholder="Write..."
          />
          <p className="text-red-500 text-xs mt-1 ml-2 font-normal">
            {errors["email"] && errors["email"]?.message}
          </p>
        </div>
        <button
          disabled={state}
          className="cursor-pointer w-full bg-[#096731] text-white py-2 mt-6 rounded">
          {!state ? (
            "Submit"
          ) : (
            <PiSpinnerBold className="text-center text-xl m-auto animate-spin " />
          )}
        </button>
      </form>
    </section>
  );
};

export default ContactFormMain;
